import {RestResource} from "../../rest";
import {TICKET_SERVER} from "../../server";
import {FAILURE_SERVER} from "../../server";
import {athubAxios} from "../../../util/athub-axios";

const ticketRestructure = new RestResource({server: TICKET_SERVER, resource: 'ticket'});
ticketRestructure.queryTicketType = () => {
    let url = `${TICKET_SERVER}/getTicketType`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, null).then(responseBody => {
            if (responseBody.data.code == "200") {
                resolve(responseBody.data.data);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

ticketRestructure.queryByTicketId = (ticketId) => {
    let url = `${TICKET_SERVER}/ticket/${ticketId}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.data.code == "200") {
                resolve(responseBody.data.result);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

ticketRestructure.insert = (ticket) => {
    let url = `${TICKET_SERVER}/ticket/add`;
    return athubAxios.postByForm(url, ticket);
}

ticketRestructure.update = (ticket) => {
    let url = `${TICKET_SERVER}/ticket/update`;
    return athubAxios.putByForm(url, ticket);
}

ticketRestructure.delete = (ticket) => {
    let url = `${TICKET_SERVER}/ticket/delete`;
    return athubAxios.post(url, ticket);
}

//根据事件类型查询故障类别
ticketRestructure.queryFailureTypeInfo = (failureCode) => {
    let url = `${TICKET_SERVER}/ticket/getFailureInfo/${failureCode}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.data.code == "200") {
                resolve(responseBody.data.failureList);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

//根据故障类别查询故障现象
ticketRestructure.queryFailureCodeInfo = (failureType) => {
    let url = `${TICKET_SERVER}/ticket/getProblemByFailureCode/` + failureType;
    return new Promise((resolve, reject) => {
        athubAxios.get(url, null).then(responseBody => {
            if (responseBody.data.code == 200) {
                resolve(responseBody.data.failureList);
            } else {
                reject(responseBody.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

//根据故障现象查询故障原因
ticketRestructure.queryProblemcodes = (id) => {
    // let url = `${TICKET_SERVER}/ticket/getReasonByProblemCode/` + failurecode;
    // return new Promise((resolve, reject) => {
    //     athubAxios.get(url, null).then(responseBody => {
    //         if (responseBody.data.code == 200) {
    //             resolve(responseBody.data.failureList);
    //         } else {
    //             reject(responseBody.data.message);
    //         }
    //     }).catch(error => {
    //         reject(error);
    //     });
    // });

    let url = `${FAILURE_SERVER}/failurelist/tree?id=${id}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url, null).then(responseBody => {
            resolve(responseBody.data)
        }).catch(error => {
            reject(error);
        });
    });
};

export default ticketRestructure;